import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Product} from '../models/product';
import {LoadProductsCompleteListSuccessAction, productsCompleteListActionTypes} from '../actions/product-complete-list';

export interface ProductsCompleteListState {
  array: Product[];
}

const initialState: ProductsCompleteListState = {
  array: []
};

export function productsCompleteListReducer(state: ProductsCompleteListState = initialState, action: Action): ProductsCompleteListState {
  switch (action.type) {
    case productsCompleteListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case productsCompleteListActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ProductsCompleteListState, action: LoadProductsCompleteListSuccessAction): ProductsCompleteListState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: ProductsCompleteListState): ProductsCompleteListState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}


export const productsCompleteListSelectors = {
  array: (state: ProductsCompleteListState) => _.get(state, 'array', [])
};
